import { HttpResponse, delay, http } from 'msw';

import { getCustomHandlerLoginStatus } from './utils';
import { MOCK_DELAY } from './utils/constants';

export const getCustomPlatformGetSyncSourceMockHandler = () => {
  return http.get('*/teams/:team/sync-sources/:sync_source_name', async () => {
    await delay(MOCK_DELAY);

    if (!getCustomHandlerLoginStatus()) {
      return new HttpResponse(null, { status: 401 });
    }

    const syncSource = {
      created_at: '2024-06-17T14:09:04.217594Z',
      display_name: '',
      draft: false,
      env: [],
      last_update_source: 'ui',
      name: 'gcp-2024-06-17',
      path: 'cloudquery/gcp',
      skip_tables: [],
      spec: {},
      tables: ['gcp_storage_buckets'],
      updated_at: '2024-06-17T14:09:04.217594Z',
      version: 'v14.1.0',
    };

    return HttpResponse.json(syncSource, {
      status: 200,
    });
  });
};
